var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 10.3333C18.6667 5.73333 14.9333 2 10.3333 2C5.73333 2 2 5.73333 2 10.3333C2 14.3667 4.86667 17.725 8.66667 18.5V12.8333H7V10.3333H8.66667V8.25C8.66667 6.64167 9.975 5.33333 11.5833 5.33333H13.6667V7.83333H12C11.5417 7.83333 11.1667 8.20833 11.1667 8.66667V10.3333H13.6667V12.8333H11.1667V18.625C15.375 18.2083 18.6667 14.6583 18.6667 10.3333Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 10.3333C18.6667 5.73333 14.9333 2 10.3333 2C5.73333 2 2 5.73333 2 10.3333C2 14.3667 4.86667 17.725 8.66667 18.5V12.8333H7V10.3333H8.66667V8.25C8.66667 6.64167 9.975 5.33333 11.5833 5.33333H13.6667V7.83333H12C11.5417 7.83333 11.1667 8.20833 11.1667 8.66667V10.3333H13.6667V12.8333H11.1667V18.625C15.375 18.2083 18.6667 14.6583 18.6667 10.3333Z",
    fill: "url(#pattern0)",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineFacebook);
export default __webpack_public_path__ + "static/media/ic_outline-facebook.c1c89cb1f67950f11086c8223ba3da34.svg";
export { ForwardRef as ReactComponent };